let claimsCols1 = [
    {
        key: 'insuranceLine',
        display: "Insurance Line"
    },
    {
        key: 'underwriterName',
        display: 'Underwriter'
    },
    {
        key: 'claimReference',
        display: 'Claim Reference'
    },
    {
        key: 'claimRelatedReference',
        display: 'Related Reference'
    },
    {
        key: 'typeLabel',
        display: 'Type'
    },
    {
        key: 'makeLabel',
        display: 'Make'
    },
    {
        key: 'modelLabel',
        display: 'Model'
    },
    {
        key: 'serialNo',
        display: 'SerialNo'
    },
    {
        key: 'imeiNo',
        display: 'IMEI'
    },
    {
        key: 'repairOptionTypeLabel',
        display: 'Type'
    },
    {
        key: 'repairProviderLabel',
        display: 'Provider'
    },    
    {
        key: 'dateCreatedAsLocalTime',
        display: 'Date Selected'
    },
    {
        key: 'dateCancelledAsLocalTime',
        display: 'Date Cancelled'
    }
]

let claimsCols2 = [
    {
        key: 'insuranceLine',
        display: "Insurance Line"
    },
    {
        key: 'underwriterName',
        display: 'Underwriter'
    },
    {
        key: 'claimReference',
        display: 'Claim Reference'
    },
    {
        key: 'claimRelatedReference',
        display: 'Related Reference'
    },
    {
        key: 'typeLabel',
        display: 'Type'
    },
    {
        key: 'makeLabel',
        display: 'Make'
    },
    {
        key: 'modelLabel',
        display: 'Model'
    },
    {
        key: 'serialNo',
        display: 'SerialNo'
    },
    {
        key: 'imeiNo',
        display: 'IMEI'
    },
    {
        key: 'repairOptionTypeLabel',
        display: 'Type'
    },
    {
        key: 'repairProviderLabel',
        display: 'Provider'
    },
    {
        key: 'dateCreatedAsLocalTime',
        display: 'Date Selected'
    }
]

export { claimsCols1, claimsCols2 }